import { API_MACHINE } from "../constants/api";
import _ from "lodash";

const getMachineOptions = (machines) => {
  let result = [{ value: null, label: "[ALL]" }];
  for (const machine of machines) {
    result.push({ value: machine.id, label: machine.name });
  }
  return result;
};

const getMachineGroupList = (inputOptions) => {
  let result = {};
  Object.entries(inputOptions).forEach((group) => {
    if (group[0] !== "machines") {
      let groupNumber = parseInt(group[0].split("_")[1]);
      result[groupNumber] = group[1].map((v) => {
        return { value: v.id, label: v.name };
      });
    }
  });
  return result;
};

const getFilterGroupList = (inputOptions) => {
  let result = {};
  Object.entries(inputOptions).forEach((group) => {
    if (group[0] !== "machines") {
      if (!result[group[0]]) {
        result[group[0]] = [{ value: "", label: "[ALL]" }];
      }
      group[1].forEach((v) => {
        if (!result[group[0]].some((g) => g.value === v.name)) {
          result[group[0]].push({ value: v.name, label: v.name });
        }
      });
    }
  });
  return result;
};

const getGroupChildren = (inputOptions, filterData, level) => {
  let result = [{ value: "", label: "[ALL]" }];
  let groupParentIds = {};
  for (let i = 1; i < level; i++) {
    groupParentIds[i] = [];
    if (!groupParentIds[i - 1] || groupParentIds[i - 1].length === 0) {
      if (inputOptions[`group_${i}`] && filterData[`group_${i}`]) {
        inputOptions[`group_${i}`].forEach((v) => {
          if (v.name === filterData[`group_${i}`]) {
            groupParentIds[i].push(v.id);
          }
        });
      }
    } else {
      if (inputOptions[`group_${i}`] && filterData[`group_${i}`]) {
        inputOptions[`group_${i}`].forEach((v) => {
          if (
            groupParentIds[i - 1].includes(v.parent_group_id) &&
            v.name === filterData[`group_${i}`]
          ) {
            groupParentIds[i].push(v.id);
          }
        });
      }
    }
  }

  if (inputOptions[`group_${level}`]) {
    inputOptions[`group_${level}`].forEach((v) => {
      if (
        groupParentIds[level - 1].includes(v.parent_group_id) &&
        !result.some((g) => g.value === v.name)
      ) {
        result.push({ value: v.name, label: v.name });
      }
    });
  }
  return result;
};

const getMachineAddFormData = (data) => {
  let newData = {};
  for (const key in data) {
    if (key !== "name" && key !== "status") {
      newData[`group_${key}_id`] = data[key];
    } else {
      newData[key] = data[key];
    }
  }
  return newData;
};

const getMachineUrl = (dataSearch) => {
  let url = "?";
  for (const key in dataSearch) {
    if (dataSearch[key] !== null && dataSearch[key] !== "") {
      url += `${key}=${dataSearch[key]}&`;
    }
  }
  url = url.slice(0, -1);
  return `${API_MACHINE}${url}`;
};

const getInitialMachineDataSort = (data) => {
  const newData = data.map((obj) => {
    const newObj = { ...obj };
    for (let i = 1; i <= 5; i++) {
      if (newObj[`group_${i}`] && newObj[`group_${i}`].name) {
        newObj[`group_${i}_name`] = newObj[`group_${i}`].name;
      }
    }
    return newObj;
  });
  return newData;
};

const getFirstSelectedGroup = (filterData) => {
  for (let i = 1; i <= 5; i++) {
    if (filterData[`group_${i}`] !== "") {
      return i;
    }
  }
  return 0;
};

const getFilterDataValid = (filterData, inputOptions, page) => {
  let newFilterData = {
    group_1: "",
    group_2: "",
    group_3: "",
    group_4: "",
    group_5: "",
  };
  if (page === "machine") {
    newFilterData["machine_id"] = null;
  }
  const getFilterValueValid = (filterKey, optionKey, groupParent = "") => {
    if (
      filterData.hasOwnProperty(filterKey) &&
      inputOptions.hasOwnProperty(optionKey)
    ) {
      let value = filterData[filterKey];
      if (value === null || value === "") {
        return;
      }
      if (filterKey === "machine_id") {
        if (inputOptions[optionKey].some((obj) => obj.id === value)) {
          newFilterData[filterKey] = value;
        }
      } else {
        parentGroups[optionKey] = [];
        if (!parentGroups.hasOwnProperty(groupParent)) {
          inputOptions[optionKey].forEach((obj) => {
            if (obj.name === value) {
              newFilterData[filterKey] = value;
              parentGroups[optionKey].push(obj.id);
            }
          });
        } else {
          inputOptions[optionKey].forEach((obj) => {
            if (
              obj.name === value &&
              parentGroups[groupParent].includes(obj.parent_group_id)
            ) {
              newFilterData[filterKey] = value;
              parentGroups[optionKey].push(obj.id);
            }
          });
        }
      }
    }
  };
  if (page === "machine") {
    getFilterValueValid("machine_id", "machines");
  }
  let parentGroups = {};
  for (let i = 1; i <= 5; i++) {
    getFilterValueValid(`group_${i}`, `group_${i}`, `group_${i - 1}`);
  }
  return newFilterData;
};

const getTableGroupOptions = (groupsChildren, groupSelect, groupsList, row) => {
  if (_.isEmpty(groupsList)) {
    return {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
    };
  }

  const mutableGroupList = _.cloneDeep(groupsList);
  const mutableGroupChildren = _.cloneDeep(groupsChildren);

  let initOptions = [];
  if (
    row.group_1 !== null &&
    !mutableGroupList[1].some((item) => item.value === row.group_1?.id)
  ) {
    mutableGroupList[1].push({
      value: row?.group_1?.id,
      label: row?.group_1?.name,
    });
  }

  if (!groupSelect || groupSelect[1] === 0 || groupSelect[1] === null) {
    return {
      1: [...initOptions, ...mutableGroupList[1]],
      2: [],
      3: [],
      4: [],
      5: [],
    };
  }

  for (let i = 1; i <= 5; i++) {
    if (row[`group_${i}`] === null || row[`group_${i}`]?.id === null) {
      continue;
    }
    if (!mutableGroupChildren.hasOwnProperty(row[`group_${i}`].id)) {
      mutableGroupChildren[row[`group_${i}`].id] = [];
    }
    if (
      row[`group_${i}`].parent_group_id !== null &&
      !mutableGroupChildren[row[`group_${i}`].parent_group_id].some(
        (item) => item.id === row[`group_${i}`].id
      )
    ) {
      mutableGroupChildren[row[`group_${i}`].parent_group_id].push(
        row[`group_${i}`]
      );
    }
  }
  const getChildren = (level) => {
    let parentLevel = level - 1;
    while (groupSelect[parentLevel] === 0 || groupSelect[1] === null) {
      parentLevel--;
    }
    let children = [];
    let parents = [groupSelect[parentLevel]];
    while (parentLevel < level) {
      children = [];
      for (let i = 0; i < parents.length; i++) {
        children = [...children, ...(mutableGroupChildren[parents[i]] ?? [])];
      }
      parentLevel++;
      parents = children.map((v) => v.id);
    }
    return children;
  };
  let result = {
    1: [...initOptions, ...mutableGroupList[1]],
    2: [],
    3: [],
    4: [],
    5: [],
  };
  for (let i = 2; i <= 5; i++) {
    let currentLevelChildren = getChildren(i);
    let levelSelect = currentLevelChildren.map((v) => {
      return { value: v.id, label: v.name };
    });
    result[i] = [...initOptions, ...levelSelect];
  }
  return result;
};

const getOriginalData = (data) => {
  const newObject = data.reduce((acc, item) => {
    acc[item.id] = {
      group_1: item.group_1,
      group_2: item.group_2,
      group_3: item.group_3,
      group_4: item.group_4,
      group_5: item.group_5,
    };
    return acc;
  }, {});
  return newObject;
};

export {
  getMachineOptions,
  getMachineUrl,
  getMachineAddFormData,
  getInitialMachineDataSort,
  getMachineGroupList,
  getFilterGroupList,
  getGroupChildren,
  getFirstSelectedGroup,
  getFilterDataValid,
  getTableGroupOptions,
  getOriginalData,
};
